var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseTrack } from "./BaseTrack.js";
import { SoundFileInstrument } from "../Nodes/SoundFileInstrument.js";
import { SecondsBaseEvent } from "../Notation/SongEvents.js";
export class SoundFileTrack extends BaseTrack {
    static create(metadata, context, scheduleEvent, connectionManager, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const o = new SoundFileTrack(metadata, context, scheduleEvent, connectionManager, settings);
            yield o.initialise();
            return o;
        });
    }
    get soundFileDuration() {
        return this._metadata.positionSecondsToQuarterNote(this.audioSource.duration);
    }
    constructor(metadata, context, scheduleEvent, connectionManager, settings) {
        super(metadata, context, scheduleEvent, new SoundFileInstrument(context, settings ? settings.source : undefined), connectionManager, settings);
        this.allowOverlaps = false;
        if (settings) {
            this.allowOverlaps = settings.allowOverlaps;
        }
    }
    initialise() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.audioSource.initialise();
        });
    }
    addOneShot(startPosition) {
        if (!this.allowOverlaps && this._timeline.getEventsBetweenTimes(startPosition, startPosition + this._metadata.positionSecondsToQuarterNote(this.audioSource.duration)).length > 0) {
            throw new RangeError("Invalid location: a playback event already occurs in the duration of the new event. Disable allowOverlaps to suppress this error.");
        }
        let event = new SecondsBaseEvent(startPosition, this._metadata, this.audioSource.duration);
        this._timeline.addEvent(event);
        return event;
    }
    removeOneShot(event) {
        this._timeline.removeEvent(event);
    }
    setSoundFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.audioSource.setSoundFile(file);
            this._timeline.events.forEach(event => {
                event.secondsDuration = this.audioSource.duration;
            });
            if (!this.allowOverlaps) {
                let index = 0;
                while (index < this._timeline.events.length) {
                    let event = this._timeline.events[index];
                    let overlappingEvents = this._timeline.getEventsBetweenTimes(event.startPosition, event.endPosition);
                    overlappingEvents.forEach(overlapEvent => {
                        if (overlapEvent != event) {
                            this._timeline.removeEvent(overlapEvent);
                        }
                    });
                    index++;
                }
            }
            this._timeline.updatePlaybackTime();
        });
    }
    serialise() {
        return {
            "id": this.id,
            "source": this.audioSource.serialise(),
            "events": this.timeline.serialise(),
            "connections": this._connectionManager.getConnections(this.audioSource),
            "allowOverlaps": this.allowOverlaps
        };
    }
    songEventHandler(event) {
        if (event instanceof SecondsBaseEvent) {
            let startPositionSeconds = this._startTime + this._metadata.positionQuarterNoteToSeconds(event.startPosition);
            this.audioSource.playOneShot(startPositionSeconds, this._context.currentTime - startPositionSeconds);
        }
        else {
            throw new Error("SoundFileTrack cannot handle this event type: " + event.constructor.name);
        }
    }
}
//# sourceMappingURL=SoundFileTrack.js.map